import { FormComponent } from '@/components/base/form/form.component';
import { IResponseError } from '@/services/rest/rest.service';
import { NoteType } from '@/entities/note/note.type';
import * as types from '@/store/types';
import { INote } from '@/entities/note/note.interface';
import * as utils from '@/utils';

export abstract class EditPage extends FormComponent {
    public isNew: boolean = true;

    protected abstract parentPath: string;

    protected id: number;

    protected model: any;

    public async created() {
        this.id = +this.$route.params['id'];
        if (this.id) {
            this.isNew = false;

            this.loading = true;
            try {
                this.model = await this.detail(this.id);
                this.loading = false;
                this.setValues(this.model);
            } catch (e) {
                this.loading = false;
            }
        }
    }

    public submit() {
        let body = this.prepare();
        this.loading = true;

        let fn = this.isNew ? this.create(body) : this.update(body);

        fn.then(
            (data) => {
                let payload: INote = {
                    total: 1,
                    guid: utils.guid(),
                    type: NoteType.Success,
                    heading: 'Success',
                    body: 'Operation Complete'
                };

                this.$store.dispatch(types.ADD_TEMP_NOTE, payload);

                this.$router.push(this.parentPath);
                this.loading = false;
            },
            (err: IResponseError) => this.processError(err)
        );
    }

    protected abstract detail(id: number): Promise<any>;

    protected abstract create(body: any): Promise<any>;

    protected abstract update(body: any): Promise<any>;
}
